export default {
    _click: 'click',
    _error: 'error',
}